export default "__VITE_ASSET__ClfS_2$d__"